<template>
<Teleport to="#modal-portal-target">
<div v-if="$store.getters['common/modalName'] === 'userreservationdisplay'">
    <div class="modal-header">
        <h3 class="modal-title">
            {{ $_formatDateTime($_dateFormat.DATETIME_DAY_NAME_SHORT, editReservation.reservation.start) }}
            {{ $_formatDateTime($_dateFormat.DATETIME_DMY, editReservation.reservation.start) }}
        </h3>
    </div>
    <div class="modal-body reservation-modal userteetime-modal">
        <div class="panel-body" style="padding: 0;">
            <h4>{{ $_locale('reservation') }}: {{ $_formatDateTime($_dateFormat.DATETIME_HI, editReservation.reservation.start) }} - {{ $_formatDateTime($_dateFormat.DATETIME_HI, editReservation.reservation.end) }}</h4>
            <h5>{{ $_locale('order number') }}: {{ editReservation.reservation.orderId }}</h5>
            <div class="row">
                <div class="col-xs-6">
                    <button @click="setReservationSaleMode(editReservation.reservation.reservationTimeId, 'onSale')"
                        v-if="[2,3].includes(editReservation.reservation.status)" 
                        class="btn btn-info btn-block">{{ $_locale('put up for sale') }}</button>
                    <button @click="setReservationSaleMode(editReservation.reservation.reservationTimeId, 'offMarket')"
                        v-if="editReservation.reservation.status == 6" 
                        class="btn btn-info btn-block">{{ $_locale('remove from market') }}</button>
                </div>
                <div class="col-xs-6">
                    <button @click="deactivateReservationTime(editReservation.reservation.reservationTimeId)"
                        class="btn btn-danger btn-block">{{ $_locale('cancel reservation') }}</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-default pull-left" 
            @click="$store.commit('common/setModal', null)">
            {{ $_locale('close') }}
        </button>
    </div>
</div>
</Teleport>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            adminMode: 'common/adminMode',
            editReservation: 'calendar/editReservation',
            date: 'reservations/date',
            product: 'ecom/product',
        }),
    },
    methods: {
        setReservationSaleMode(reservationTimeId, mode) {
            const EcomService = this.$store.getters['ecom/EcomService'];
            this.$store.commit('common/setModal', null);

            EcomService.setReservationSaleMode({
                productId: this.product.productId,
                mode,
                reservationTimeId
            })
            .then((response) => {
                const { data } = response;
                
                if (data.success) {
                    this.$store.dispatch('reservations/onDateChange', this.date);
                } else {
                    this.$_swal({ icon: 'error', title: data.message })
                }
            })
        },
        deactivateReservationTime(reservationTimeId) {
            const EcomService = this.$store.getters['ecom/EcomService'];
            
            this.$_swal({
                title: _locale('are you sure').ucfirst(),
                text: '',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn-warning',
                confirmButtonText: _locale('yes').ucfirst(),
                cancelButtonText: _locale('no').ucfirst()
            })
            .then((result) => {
                if (result.isConfirmed) {
                    this.$store.commit('common/setModal', null);
                    
                    EcomService.deactivateReservationTime(reservationTimeId)
                        .then((response) => {
                            const { data } = response;
                            
                            if (data.success) {
                                this.$store.dispatch('reservations/onDateChange', this.date);
                                
                                this.$_swal({ icon: 'success', title: _locale('deleted').ucfirst() })
                            } else {
                                this.$_swal({ icon: 'error', title: data.message })
                            }
                        })
                }
            })
        },
    }
}
</script>